import { Grid } from '@material-ui/core';
import { Flex, Margin, WhiteSection } from 'components/base/layout-components';
import Text from 'components/base/Text';
import { SPACES } from '@linearb/linui-common';
import useToast from 'components/hooks/useToast';
import useConfirmModal from 'components/hooks/useConfirmModal';
import { ERROR_TYPES } from 'common/constants/error-types';
import { LBButton } from '@linearb/buzz';

const SettingWrapper = ({
  children,
  title,
  description,
  onSave,
  isSaveDisabled,
  onRestore,
  isRestoreDisabled
}) => {
  const toast = useToast();
  const confirmModal = useConfirmModal();

  const _onSave = async () => {
    try {
      await onSave();
      toast({ message: 'Setting updated successfully' });
    } catch (e) {
      switch (e.type) {
        case ERROR_TYPES.VALIDATION_ERROR:
          return toast({
            variant: 'error',
            message: e.message || 'Input is invalid'
          });
        default:
          return toast({
            variant: 'error',
            message: 'Failed to update setting'
          });
      }
    }
  };

  const _onRestore = async () => {
    const isConfirmed = await confirmModal({
      title: 'Restore to default',
      description: 'Are you sure you want to reset to the default value?',
      confirmText: 'Confirm'
    });
    if (!isConfirmed) return;

    try {
      await onRestore();
      toast({ message: 'Setting restored successfully' });
    } catch (e) {
      return toast({
        variant: 'error',
        message: 'Failed to restore setting to default'
      });
    }
  };

  return (
    <WhiteSection>
      <Flex align='center' direction='column' width='60%'>
        <Flex direction='column'>
          <Text size='large' color='abbey' weight='500' pb={SPACES.medium}>
            {title}
          </Text>
          <Grid container spacing={1}>
            <Grid item>
              <Text
                lineHeight={1.7}
                size='large'
                pb={SPACES.medium}
                color='darkGray'
              >
                {description}
              </Text>
            </Grid>
          </Grid>
          {children}
        </Flex>
        <Margin style={{ alignSelf: 'flex-end' }} t='small'>
          <Grid spacing={1} container>
            <Grid item>
              <LBButton
                size='lg'
                variant='outline'
                onClick={_onRestore}
                disabled={isRestoreDisabled}
              >
                Restore Default
              </LBButton>
            </Grid>
            <Grid item>
              <LBButton onClick={_onSave} size='lg' disabled={isSaveDisabled}>
                Save
              </LBButton>
            </Grid>
          </Grid>
        </Margin>
      </Flex>
    </WhiteSection>
  );
};

export default SettingWrapper;
